import { apiInstance } from "v2/infrastructure/common/api/apiClient";

const sendRejectBenefitRequest = async ({
  companyId,
  requestId,
  reason,
}: {
  companyId: string;
  requestId: string;
  reason: string;
}): Promise<void> => {
  await apiInstance.put(
    `/v1/companies/${companyId}/benefit-requests/${requestId}/state`,
    { action: "deny", reason }
  );
};

export default sendRejectBenefitRequest;
